export default (numerator, denominator) => {
  if (denominator === 0) return "0";

  const ratio = numerator / denominator;

  if (ratio === 0) return "0";

  let str = ratio.toFixed(2);

  if (str.endsWith(".00")) return parseInt(str, 10).toString();
  if (str.endsWith("0")) return parseFloat(str).toString();

  return str;
};
